<div class="container mt-4">
  <div class="card shadow-sm">
    <!-- <div class="card-header bg-primary text-white" style="background-color: #ffffff !important;">
      <h4 class="mb-0"> {{ 'MENU.DASHBOARD.investor_detailss' | translate }}</h4>
    </div> -->
    <!-- <div class="card-body mt-2">
      <div *ngIf="investor; else loading">
        <div class="row">
          <div class="col-md-6 mb-3">
            <strong>{{ 'MENU.DASHBOARD.name' | translate }}:</strong>
            <p class="mb-0">{{ investor.name || 'N/A' }}</p>
          </div>

          <div class="col-md-6 mb-3">
            <strong>{{ 'MENU.DASHBOARD.email' | translate }}:</strong>
            <p class="mb-0">{{ investor.email || 'N/A' }}</p>
          </div>

          <div class="col-md-6 mb-3">
            <strong>{{ 'MENU.DASHBOARD.phone' | translate }}:</strong>
            <p class="mb-0">{{ investor.phone || 'N/A' }}</p>
          </div>

          <div class="col-md-6 mb-3">
            <strong>{{ 'MENU.DASHBOARD.employee_id' | translate }}:</strong>
            <p class="mb-0">{{ investor.employee_id || 'N/A' }}</p>
          </div>

          <div class="col-md-6 mb-3">
            <strong>{{ 'MENU.DASHBOARD.type' | translate }}:</strong>
            <p class="mb-0 text-capitalize">{{ investor.type || 'N/A' }}</p>
          </div>

          <div class="col-md-6 mb-3">
            <strong>{{ 'MENU.DASHBOARD.status' | translate }}:</strong>
            <p class="mb-0">
              <span
                class="badge"
                [ngClass]="investor.is_active ? 'bg-success' : 'bg-danger'"
              >
                {{ investor.is_active ? 'Active' : 'Inactive' }}
              </span>
            </p>
          </div>

          <div class="col-md-12 text-center mt-4">
            <strong>{{ 'MENU.DASHBOARD.image' | translate }}:</strong><br />
            <img
              *ngIf="investor.image; else noImage"
              [src]="investor.image"
              alt="Investor Image"
              class="img-thumbnail mt-2"
              style="width: 130px; height: 130px; object-fit: cover; border-radius: 50%;"
            />
            <ng-template #noImage>
              <p class="text-muted mt-2"> {{ 'MENU.DASHBOARD.no_image_available' | translate }}</p>
            </ng-template>
          </div>
        </div>
      </div>

      <ng-template #loading>
        <p>{{ 'MENU.DASHBOARD.loading_investor_details' | translate }}</p>
      </ng-template>
    </div> -->
  </div>
</div>
<!-- ------------------------------------------------------------------------------------ -->

  <!-- <div class="employee-card" *ngIf="investor; else loading">
        <div class="card-header">
            <div class="employee-image">
               <img
              *ngIf="investor.image; else noImage"
              [src]="investor.image"
              alt="Employee Image"
              class="img-thumbnail mt-2"
              style="width: 120px; height: 120px; object-fit: cover; border-radius: 50%;"
            />
               
            </div>
            <ng-template #noImage>
               <i class="fas fa-user"></i>
            </ng-template>
            <h1 class="employee-name">{{ investor.name || 'N/A' }}</h1>
            <p class="employee-title">Investor</p>
            <span class="status-badge" [ngClass]="investor.is_active ? 'bg-success' : 'bg-danger'" > {{ investor.is_active ? 'Active' : 'Inactive' }} </span>
        </div>
        
        <div class="card-body">
          
            
            <div class="info-group">
               <div class="employee-image">
               <img
              *ngIf="investor.image; else noImage"
              [src]="investor.image"
              alt="Employee Image"
              class="img-thumbnail mt-2"
              style="width: 120px; height: 120px; object-fit: cover; border-radius: 50%;"
            />
               
            </div>
            <ng-template #noImage>
               <i class="fas fa-user"></i>
            </ng-template>
                <div class="info-icon">
                    <i class="fas fa-envelope"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label"> {{ 'MENU.DASHBOARD.email' | translate }} </div>
                    <div class="info-value">{{ investor.email || 'N/A' }}</div>
                </div>
            </div>
             <div class="divider"></div>
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-phone"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label">phone : </div>
                    <div class="info-value">{{ investor.phone || 'N/A' }}</div>
                </div>
            </div>
            
            <div class="divider"></div>
            
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-id-card"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label"> {{ 'MENU.DASHBOARD.employee_id' | translate }}: </div>
                    <div class="info-value n-a"> {{ investor.employee_id || 'N/A' }}</div>
                </div>
            </div>
            
           
            
            <div class="divider"></div>
            
            <div class="info-group">
                <div class="info-icon">
                    <i class="fas fa-user-tag"></i>
                </div>
                <div class="info-content mx-1">
                    <div class="info-label"> {{ 'MENU.DASHBOARD.type' | translate }}: </div>
                    <div class="info-value n-a">{{ investor.type || 'N/A' }} </div>
                </div>
            </div>
            
          
        </div>
        
  </div>  -->

  <!-- <ng-template #loading>
    <p>{{ 'MENU.DASHBOARD.loading_investor_details' | translate }}</p>
  </ng-template> -->

  <!-- ----------------------------------------------------------- -->

   <!-- <div class="investor-container" *ngIf="investor; else loading"> -->
    <div *ngIf="!investor">
  <p>{{ 'MENU.DASHBOARD.loading_investor_details' | translate }}</p>
</div>

<div class="investor-container" *ngIf="investor">
        <!-- Sidebar -->
        <div class="investor-sidebar"> 
            
             <div class="employee-image">
               <img
              *ngIf="investor.image; else noImage"
              [src]="investor.image"
              alt="Employee Image"
              class="img-thumbnail mt-2"
              style="width: 120px; height: 120px; object-fit: cover; border-radius: 50%;"
            />
               
            </div>
            <ng-template #noImage>
               <div class="investor-avatar">
                <i class="fas fa-user-tie"></i>
            </div>
            </ng-template>
               

            <h1 class="investor-name">{{ investor.name || 'N/A' }}</h1>
            <!-- <p class="investor-type"> {{ 'MENU.DASHBOARD.investor_detailss' | translate }}</p> -->
            <!-- <span class="status-badge" [ngClass]="investor.is_active ? 'bg-success' : 'bg-danger'" > {{ investor.is_active ? 'Active' : 'Inactive' }} </span> -->
            <span class="status-badge" [ngClass]="investor.is_active ? 'bg-success' : 'bg-danger'">
  {{ investor.is_active ? ('MENU.DASHBOARD.Active' | translate) : ('MENU.DASHBOARD.inActive' | translate) }}
</span>    
            <div class="sidebar-stats">
                <div class="stat-item">
                    <span class="stat-label" ><i class="fas fa-file-contract"></i> {{ 'MENU.DASHBOARD.contracts' | translate }}  </span>
                    <!-- <span class="stat-value">2024</span> -->
                </div>
                <div class="stat-item" *ngFor="let contract of contracts">
                    <span class="stat-value" (click)="contractDetailsById(contract.id)"><a style="color:#fff ">{{contract.serial_number}} </a></span>
                    <span class="stat-value"> {{contract.contract_type_name}}</span>
                </div>
                <!-- <div class="stat-item">
                    <span class="stat-label">Status</span>
                    <span class="stat-value">Active</span>
                </div> -->
            </div>
        </div>
        
        <!-- Main Content -->
        <div class="investor-main">
            <!-- Contact Information Section -->
            <div class="section-header">
                <div class="section-icon ml-1">
                    <i class="fas fa-address-card"></i>
                </div>
                <h2 class="section-title">{{ 'MENU.DASHBOARD.investor_details' | translate }}</h2>
            </div>
            
            <div class="info-grid">
                <div class="info-card">
                    <div class="info-label">
                        <i class="fas fa-envelope"></i>
                       {{ 'MENU.DASHBOARD.email' | translate }} 
                    </div>
                    <div class="info-value">{{ investor.email || 'N/A' }}</div>
                </div>
                
                <div class="info-card">
                    <div class="info-label">
                        <i class="fas fa-phone"></i>
                       {{ 'MENU.DASHBOARD.phone' | translate }}  
                    </div>
                    <div class="info-value">{{ investor.phone_without_code || 'N/A' }}</div>
                </div>
                
                <div class="info-card" [routerLink]="['/employees-details',investor.employee?.id]" style="cursor: pointer;">
                    <div class="info-label">
                        <i class="fas fa-id-card"></i>
                       {{ 'MENU.DASHBOARD.responsible_employee' | translate }}
                    </div>
                    <div class="info-value " [routerLink]="['/employees-details',investor.employee?.id]"> {{ investor.employee?.name || 'N/A' }}</div>
                </div>
                
                <div class="info-card">
                    <div class="info-label">
                        <i class="fas fa-user-tag"></i>
                         {{ 'MENU.DASHBOARD.nationality' | translate }}
                    </div>
                    <div class="info-value">{{ investor.nationality.name || 'N/A' }}</div>
                </div>
                  <div class="info-card">
                    <div class="info-label">
                       <i class="fas fa-map-marker-alt"></i>
                         {{ 'MENU.DASHBOARD.city' | translate }}
                    </div>
                    <div class="info-value"> {{  investor?.city?.name }}</div>
                </div>
            </div>
            
            <!-- Additional Information Section -->
            <div class="section-header">
                <div class="section-icon ml-1" *ngIf="contracts" >
                    <i class="fas fa-chart-line"></i>
                </div>
                <h2 class="section-title">{{ 'MENU.DASHBOARD.Upcoming_payments' | translate }}</h2>
            </div>



                       <div class="d-flex justify-content-between align-items-center mb-3">

  <!-- Select All -->
  <div>
    <input
      type="checkbox"
      [(ngModel)]="selectAll"
      (change)="toggleSelectAll()"
    />
    <span class="mx-2">
      {{ 'MENU.DASHBOARD.select_all' | translate }}
    </span>
  </div>

  <!-- Pay Selected -->
  <!-- <button
    class="btn btn-success" style="background-color: #cca44c !important;"
    [disabled]="selectedInstallments.length === 0"
    (click)="paySelected()"
  >
    {{ 'MENU.DASHBOARD.pay_selected' | translate }}
  </button> -->

  <button
  class="btn"
  style="background-color:#cca44c;color:#fff"
  [disabled]="selectedInstallments.length === 0"
  (click)="openPaymentModal(paymentModal)"
>
  {{ 'MENU.DASHBOARD.pay_selected' | translate }}
</button>

</div>
         


            
             <div class="info-grid">
            <div class="info-card" *ngFor="let inst of contracts">
            
                <div class="info-label">
                   <i class="fas fa-address-card"></i>
                    <span style="font-weight: 500;" class="mx-1"> {{ 'MENU.DASHBOARD.contract' | translate }} : </span> {{inst.serial_number}} 
                </div>
               
                <!-- <div class="info-value">
                    <i class="fas fa-hand-holding-usd" style="color:#cca44c ;"></i> 
                    <span style="font-weight: 500;" class="mx-1"> {{ 'MENU.DASHBOARD.amount' | translate }} : </span> {{inst.next_installment.amount}} {{ 'MENU.DASHBOARD.rs' | translate }} 
                </div> -->


                <div class="info-value my-2">
  <i class="fas fa-money-check-alt" style="color:#cca44c;"></i>
  <span class="mx-1 fw-bold">{{ 'MENU.DASHBOARD.from_amount' | translate }}:</span>
  {{ getAmountFrom(inst) | number:'1.2-2' }} {{ 'MENU.DASHBOARD.rs' | translate }}
  <span class="text-muted ms-2 mx-3">
    ({{ getAmountPercentage(inst) }}%)
  </span>
</div>

<div class="info-value" *ngIf="inst?.next_installment?.amount">
  <i class="fas fa-percentage" style="color:#cca44c;"></i>

  <span style="font-weight: 500;" class="mx-1">
    {{ 'MENU.DASHBOARD.Ratio' | translate }} ({{ 'MENU.DASHBOARD.from_amount' | translate }}):
  </span>

  <div class="w-100 mt-1">
    <div class="progress" style="height: 8px;">
      <div
        class="progress-bar"
        role="progressbar"
        [class.bg-success]="getAmountRatio(inst) >= 75"
        [class.bg-warning]="getAmountRatio(inst) < 75 && getAmountRatio(inst) >= 40"
        [class.bg-danger]="getAmountRatio(inst) < 40"
        [style.width.%]="getAmountRatio(inst)"
      ></div>
    </div>
  </div>
</div>

<div class="info-value my-2">
  <i class="fas fa-money-bill-trend-up" style="color:#cca44c;"></i>
  <span class="mx-1 fw-bold">{{ 'MENU.DASHBOARD.to_amount' | translate }}:</span>
  {{ getAmountTo(inst) | number:'1.2-2' }} {{ 'MENU.DASHBOARD.rs' | translate }}
  <span class="text-muted ms-2  mx-3">
    ({{ getAmountMaxPercentage(inst) }}%)
  </span>
</div>

<div class="info-value mt-2" *ngIf="inst?.next_installment?.amount_max">
  <i class="fas fa-percentage" style="color:#cca44c;"></i>

  <span style="font-weight: 500;" class="mx-1">
    {{ 'MENU.DASHBOARD.Ratio' | translate }} ({{ 'MENU.DASHBOARD.to_amount' | translate }}):
  </span>

  <div class="w-100 mt-1">
    <div class="progress" style="height: 8px;">
      <div
        class="progress-bar"
        role="progressbar"
        [class.bg-success]="getAmountMaxRatio(inst) >= 75"
        [class.bg-warning]="getAmountMaxRatio(inst) < 75 && getAmountMaxRatio(inst) >= 40"
        [class.bg-danger]="getAmountMaxRatio(inst) < 40"
        [style.width.%]="getAmountMaxRatio(inst)"
      ></div>
    </div>
  </div>
</div>
                <div class="info-value">
                    <i class="fas fa-circle mt-1" style="color:#cca44c ;"></i>
                    <span style="font-weight: 500;" class="mx-1"> {{ 'MENU.DASHBOARD.status' | translate }} : </span> {{inst.next_installment.status_text}} 
                </div>
                 <div class="info-value">
                    <i class="fas fa-calendar-alt" style="color:#cca44c ;"></i>
                    <span style="font-weight: 500;" class="mx-1"> {{ 'MENU.DASHBOARD.payment_data' | translate }} : </span> {{inst.next_installment.payment_date}} 
                </div>

<div class="info-value" *ngIf="inst?.investment_amount && inst?.next_installment?.amount">


  


<!-- 
  <i class="fas fa-percentage" style="color:#cca44c;"></i>
  <span style="font-weight: 500;" class="mx-1">
    {{ 'MENU.DASHBOARD.Ratio' | translate }} :
  </span> -->

  
  <!-- <div class="w-100 mt-1">
    <div class="progress" style="height: 8px;">
 <div
  class="progress-bar"
  role="progressbar"
  [class.bg-success]="getInvestmentRatio(inst) >= 75"
  [class.bg-warning]="getInvestmentRatio(inst) < 75 && getInvestmentRatio(inst) >= 40"
  [class.bg-danger]="getInvestmentRatio(inst) < 40"
  [style.width.%]="getInvestmentRatio(inst)"
></div> -->

    </div>

    <!-- <small class="text-muted">
      {{ getInvestmentRatio(inst) }}%
    </small> -->


<div class="info-card mt-2" *ngFor="let inst of contracts">

  <div class="text-end mb-2">
    <input
      type="checkbox"
      [checked]="isSelected(inst.next_installment?.id)"
      (change)="toggleInstallment(inst.next_installment?.id)"
    />
  </div>

  <div class="info-label">
    <i class="fas fa-address-card"></i>
    <span style="font-weight:500" class="mx-1">
      {{ 'MENU.DASHBOARD.contract' | translate }} :
    </span>
    {{inst.serial_number}}
  </div>



  </div>

                 <button  class="btn btn-add  mt-1" ngbDropdownItem  (click)="addPayment(inst.next_installment?.id)" >{{ 'MENU.DASHBOARD.add_payment' | translate }} </button>
            </div>
            </div>

 

            <!-- Action Buttons -->
           <!-- <div class="action-buttons">
                <button class="btn btn-primary">
                    <i class="fas fa-edit"></i>
                    Edit Information
                </button>
                <button class="btn btn-secondary">
                    <i class="fas fa-envelope"></i>
                    Send Message
                </button>
                <button class="btn btn-secondary">
                    <i class="fas fa-file-pdf"></i>
                    Export PDF
                </button>
            </div>  -->
        </div>
    </div>
    <ng-template #loading>
    <p>{{ 'MENU.DASHBOARD.loading_investor_details' | translate }}</p>
  </ng-template>



  <ng-template #paymentModal let-modal>

  <div class="modal-header" style="background:#cca44c;color:white">
    <h5 class="modal-title">
      {{ 'MENU.DASHBOARD.pay_selected' | translate }}
    </h5>
<button type="button" class="btn" 
        (click)="modal.dismiss()" 
        style="background:transparent;border:none;font-size:1.2rem;color:white;">
  <i class="fas fa-times"></i>
</button>  </div>

  <div class="modal-body">

    <p class="text-muted mb-3">
      {{selectedInstallments.length}} {{ 'MENU.DASHBOARD.installments_selected' | translate }}
    </p>

    <!-- Amount -->
    <div class="mb-3">
      <label class="form-label">
        {{ 'MENU.DASHBOARD.amount' | translate }}
      </label>
      <input
        type="number"
        class="form-control"
        [(ngModel)]="paymentData.paid_amount"
        placeholder="  {{ 'MENU.DASHBOARD.amount' | translate }}"
      />
    </div>

    <!-- Payment Date -->
    <div class="mb-3">
      <label class="form-label">
        {{ 'MENU.DASHBOARD.payment_date' | translate }}
      </label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="paymentData.payment_date"
      />
    </div>

    <!-- Payment Method -->
    <div class="mb-3">
      <label class="form-label">
        {{ 'MENU.DASHBOARD.payment_method' | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="paymentData.payment_method"
        placeholder="{{ 'MENU.DASHBOARD.enter_payment_method' | translate }}"
      />
    </div>

    <!-- File -->
    <div class="mb-3">
      <label class="form-label">
        {{ 'MENU.DASHBOARD.transfer_file' | translate }}
      </label>
      <input
        type="file"
        class="form-control"
        (change)="onFileSelected($event)"
      />
    </div>

  </div>

  <div class="modal-footer">

    <button
      class="btn btn-light"
      (click)="modal.dismiss()"
    >
      {{ 'MENU.DASHBOARD.cancel' | translate }}
    </button>

    <button
      class="btn"
      style="background:#cca44c;color:white"
      (click)="submitBulkPayment(modal)"
    >
     {{ 'MENU.DASHBOARD.submit_payment' | translate }}
    </button>

  </div>

</ng-template>